import { stateSetters, stateGetters } from '@/store/store-utils'
import socketActions from '@/store/modules/games/spinners/socket-actions'
import SpinnersGame from '@/store/models/games/spinners/SpinnersGame'

const defaultState = {
  games: null,
  history: [],
}

export default {
  name: 'games/spinners',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    activeGames() {
      return SpinnersGame.all()
    },
  },
  mutations: {
    ...stateSetters(defaultState),
    addHistoryRound(state, round) {
      // avoid dupe
      if (state.history.find(i => i.id === round.id)) return

      if (state.history.length > 30) {
        state.history.pop()
      }

      state.history.unshift(round)
    },
  },
  actions: {
    ...socketActions,
    async join({ commit }, { id, color }) {
      if (!id || !color) throw new Error('InvalidParams')

      await this.$api.games.spinners.join(id, color)
    },
    async requestBot({ commit }, { id, color }) {
      if (!id || !color) throw new Error('InvalidParams')

      await this.$api.games.spinners.requestBot(id, color)
    },
    async expire({ commit }, id) {
      if (!id) throw new Error('InvalidParams')

      await this.$api.games.spinners.expire(id)
    },
    async create({ commit }, form) {
      if (!form.amount) throw new Error('InvalidParams')

      await this.$api.games.spinners.create(form)
    },
  },
}
